import ErrorFeedback from 'Components/ErrorFeedback'
import PageContainer from 'Components/PageContainer'
import {
  EmptyState,
  Loading,
  SpacingVertical,
  ToastContainer,
  Tooltip
} from 'mailup-web-components'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useHistory, useParams } from 'react-router-dom'
import { useRecoilCallback, useRecoilValue } from 'recoil'
import Header from './components/Header'
import Results from './components/Results'
import Search from './components/Search'
import { cleanupCallback, searchCallback } from './recoil/callbacks/callbacks'
import { pageState, resultsStateEmptyState } from './recoil/state/page'

const SourceViewContent = () => {
  const intl = useIntl()
  const { loading, loaded, error, severity, searching } =
    useRecoilValue(pageState)
  const cleanup = useRecoilCallback(cleanupCallback, [])
  const search = useRecoilCallback(searchCallback, [])
  const { idSource, idType } = useParams()
  const history = useHistory()
  const isEmptyState = useRecoilValue(resultsStateEmptyState)

  useEffect(() => {
    return () => {
      cleanup()
    }
  }, [])

  useEffect(() => {
    !loaded && !searching && search(idSource, true)
  }, [loaded])

  const goToSource = () => {
    history.push('/automation/source/' + idType + '/' + idSource)
  }

  const onReload = async () => {
    await cleanup()
    search(idSource, true)
  }

  return (
    <>
      <Header />
      <ToastContainer />
      <Tooltip />
      <Loading open={loading} />
      <ToastContainer />
      <PageContainer className='c-source-view-content'>
        <ErrorFeedback
          error={error}
          severity={severity}
          onClickReload={onReload}
        />
        {!error && loaded && (
          <>
            {isEmptyState && (
              <>
                <EmptyState
                  title={intl.formatMessage({
                    id: 'Load.ContentsSourcesViewContents.EmptyStateTitle'
                  })}
                  description={intl.formatMessage({
                    id: 'Load.ContentsSourcesViewContents.EmptyStateDescr'
                  })}
                  buttonText={intl.formatMessage({
                    id: 'Load.ContentsSourcesViewContents.EditButton'
                  })}
                  onClickButton={goToSource}
                />
              </>
            )}
            {!isEmptyState && (
              <>
                <Search />
                <SpacingVertical />
                <Results />
              </>
            )}
          </>
        )}
      </PageContainer>
    </>
  )
}

export default SourceViewContent
